module.exports = __webpack_public_path__ + "img/add-bg-2.40b6c704.png";